import React from 'react';
import {SectionMain, Tabs, Tab} from 'components/core';
import OperationsList from './list';
import OperationsPanel from './panel';
import Singletons from 'controllers/Singletons';
import {OperationsCtxProvider, OperationsCtx} from 'components/dataProviders/operations';
import CreateDialog from './create';

export default function OperationsWrapper()
{
  return <OperationsCtxProvider><Operations></Operations></OperationsCtxProvider>
}


function Operations()
{
    const [selectedTab, setSelectedTab] = React.useState(0);
    const [showOperation, setShowOperation] = React.useState(false);
    const [selectedOperation, setSelectedOperation] = React.useState(null);
    const [newDialogOpen, setNewDialogOpen] = React.useState(false);
    

    const opsCtx = React.useContext(OperationsCtx);
    

    React.useEffect(function ClearNotifications(){
      opsCtx.funcs.clearNotifications(selectedOperation);
    }, [opsCtx, selectedOperation]);


    const handleRowSelected = (row) =>
    {
      setSelectedOperation(row.id);
      setShowOperation(true);
    }

    const handleNewButtonClick = () =>
    {
      setNewDialogOpen(true);
    }

    const handleTabChange = (index) =>
    {
      if(index !== selectedTab)
      {
        setShowOperation(false);
        setSelectedOperation(null);
        setSelectedTab(index);
      }
    }

    const handleClosePanel = () =>
    {
        setShowOperation(false);
        setSelectedOperation(null);
    }

    const tabs = <Tabs value={selectedTab} onChange={(evt, index) => handleTabChange(index)} textColor="primary" indicatorColor="primary">
        <Tab label="Tickets Abiertos"/>
        <Tab label="Tickets Archivados"/>
    </Tabs>

    const panel = <OperationsPanel operationID={selectedOperation} onClose={() => handleClosePanel()}/>

    return <SectionMain title="Asistencias" buttonLabel="Nuevo Ticket" tabs={tabs} showDetail={showOperation} onButtonClick={() => handleNewButtonClick()} detail = {panel} buttonDisabled={Singletons.currentUser.profiles.indexOf("operators") === -1}>
      <CreateDialog open={newDialogOpen} onClose={()=>setNewDialogOpen(false)} />
      <OperationsList onRowSelected={(row) => handleRowSelected(row)} collapsed={showOperation} dataset={selectedTab === 0 ? "open": "closed"}/>
    </SectionMain>
}
